var map = {
	"./Abrechnung.svg": 40003,
	"./Academy.svg": 49398,
	"./Akte.svg": 47649,
	"./Anprobe.svg": 27811,
	"./Apassung-Stoma.svg": 19502,
	"./Aufzaehlung-Punkt-rot.svg": 64501,
	"./Aufzaehlung-Punkt.svg": 11921,
	"./Aufzaehlung-Service.svg": 40273,
	"./Aussendienst.svg": 27375,
	"./Ausstattung.svg": 67593,
	"./Beratung.svg": 65004,
	"./Besteck.svg": 70041,
	"./Bestellmoeglichkeiten.svg": 87479,
	"./Brief.svg": 36030,
	"./Entlastung-Administration.svg": 13113,
	"./Experten.svg": 97884,
	"./Fax.svg": 66859,
	"./Finanzen.svg": 99344,
	"./Handschuhe.svg": 14629,
	"./Hautschutzcreme.svg": 56867,
	"./Heime.svg": 49691,
	"./Kostenabrechnung.svg": 33241,
	"./Kostenloser-Versandt.svg": 13390,
	"./Krankenkasse.svg": 38744,
	"./Kreislauf.svg": 14749,
	"./Kundendienst.svg": 83201,
	"./Lieferort.svg": 92705,
	"./Lieferung.svg": 61850,
	"./Logistik.svg": 57352,
	"./Mail.svg": 56157,
	"./Marketing.svg": 3475,
	"./Medizinische-Hilfsmittel.svg": 65159,
	"./MiGeL.svg": 86221,
	"./Mission.svg": 28904,
	"./Negativ.svg": 51563,
	"./Pants.svg": 70171,
	"./Patient.svg": 4823,
	"./Patienten-und-Fachpersonen.svg": 222,
	"./Pfeil-nach-unten.svg": 14706,
	"./Pfeil-rechts.svg": 43359,
	"./Positiv.svg": 33619,
	"./Produktanwendung.svg": 67379,
	"./Produktberatung.svg": 13189,
	"./Produktspezialisten.svg": 23254,
	"./Prozessoptimierung-Effiziente-Prozesse.svg": 9684,
	"./QR-Prozesse-IT.svg": 55692,
	"./Raumangebot.svg": 45887,
	"./Rechtslage.svg": 70581,
	"./Rundgang.svg": 67452,
	"./Schwerpunkt.svg": 55305,
	"./Services.svg": 17795,
	"./Shuttlebus.svg": 17998,
	"./Spital.svg": 25147,
	"./Spitex1.svg": 21633,
	"./Spitex2.svg": 54350,
	"./Sprechblase.svg": 38583,
	"./Standort.svg": 12831,
	"./Tasse.svg": 64954,
	"./Transparenz-Materialkosten.svg": 36091,
	"./Veranstaltungen.svg": 27830,
	"./Verbandsmaterial.svg": 4606,
	"./Vision.svg": 18258,
	"./Webinare.svg": 50965,
	"./add-circle-1.svg": 6912,
	"./alert-circle-orange.svg": 75208,
	"./alert-circle-red.svg": 98884,
	"./ambulance-car.svg": 97233,
	"./archive.svg": 10307,
	"./arrow-button-down-1.svg": 5484,
	"./arrow-button-down-nav.svg": 54462,
	"./arrow-button-down-white.svg": 51177,
	"./arrow-button-down.svg": 64963,
	"./arrow-button-right.svg": 90657,
	"./arrow-button-up-1.svg": 74110,
	"./arrow-button-up.svg": 47331,
	"./bin-2-alternate.svg": 41640,
	"./bin.svg": 69281,
	"./building-1.svg": 51295,
	"./calendar-add-1-white.svg": 1025,
	"./calendar-add-1.svg": 26804,
	"./calendar.svg": 33627,
	"./check-blue.svg": 3382,
	"./check.svg": 33844,
	"./close.svg": 97707,
	"./cog-double-2.svg": 64937,
	"./common-file-empty-alternate.svg": 52151,
	"./content-paper-edit.svg": 52102,
	"./delivery-door.svg": 43511,
	"./delivery-package-person.svg": 26215,
	"./delivery-truck-3.svg": 83896,
	"./diagram-arrow-down.svg": 70753,
	"./diagram-arrow-left.svg": 99279,
	"./diagram-arrow-right.svg": 42927,
	"./diagram-arrow-up.svg": 24844,
	"./drawer-open.svg": 54259,
	"./email-action-check.svg": 19042,
	"./email-action-edit.svg": 92137,
	"./envelope.svg": 49652,
	"./external-download.svg": 45628,
	"./external-upload.svg": 51444,
	"./filter-2.svg": 62537,
	"./hourglass.svg": 89966,
	"./house-4.svg": 87553,
	"./information-circle.svg": 63134,
	"./list-bullets-1.svg": 60259,
	"./loading-circle-1.svg": 49405,
	"./login-2.svg": 84044,
	"./logout-2.svg": 84954,
	"./megaphone.svg": 64631,
	"./messages-bubble-empty-alternate.svg": 83699,
	"./messages-bubble-square-menu.svg": 99576,
	"./migel-nok.svg": 34528,
	"./migel-ok.svg": 66607,
	"./minus.svg": 8842,
	"./navigation-arrows-down.svg": 95929,
	"./navigation-menu.svg": 76277,
	"./network-1.svg": 87591,
	"./office-file-pdf-1.svg": 23583,
	"./pathfinder-merge.svg": 1968,
	"./pencil-1.svg": 28412,
	"./phone.svg": 52130,
	"./pin-2.svg": 12665,
	"./pin.svg": 92586,
	"./plus.svg": 24155,
	"./print-text.svg": 95419,
	"./professional-network-linkedin.svg": 26303,
	"./replacement.svg": 65058,
	"./road-sign-warning.svg": 7266,
	"./road-traffic-lights.svg": 77786,
	"./search-1.svg": 76725,
	"./settings-slider-alternate.svg": 15396,
	"./shipment-in-transit.svg": 36175,
	"./shipment-nok.svg": 39502,
	"./shipment-not-possible.svg": 28103,
	"./shipment-ok.svg": 87531,
	"./shopping-bag-sad.svg": 32378,
	"./shopping-cart-add.svg": 9193,
	"./shopping-cart-empty-1.svg": 4202,
	"./single-neutral-home.svg": 54690,
	"./single-woman.svg": 10474,
	"./social-instagram.svg": 45827,
	"./social-media-facebook-1.svg": 96183,
	"./sort-alpha-down.svg": 83227,
	"./sort-alpha-up.svg": 59055,
	"./toggle_off.svg": 65005,
	"./toggle_on.svg": 43746,
	"./trip-distance.svg": 15201,
	"./upload-square-3.svg": 66368,
	"./view-1.svg": 44733,
	"./view-off.svg": 53629,
	"./warehouse-package-search.svg": 75952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39632;